import React from "react";
import {
  Handshake, Compass, ArrowsClockwise, ShieldCheck, Coins, MapPin,
} from "@phosphor-icons/react";
import ComingSoonShell from "@/components/ComingSoonShell";

/**
 * /dashboard/futuro/network · Coming-soon per la collaborazione tra agenti.
 *
 * Iter 308 r3: sostituisce le vecchie pagine "Marketplace" e "Mandati di
 * vendita" che creavano confusione. Il messaggio è ora chiaro:
 *   1) bacheca per condividere mandati (Offro)
 *   2) bacheca per cercare immobili per clienti (Cerco)
 *   3) co-mediazione semplice, accordi diretti, niente burocrazia
 */
export default function NetworkComingSoon() {
  return (
    <ComingSoonShell
      testid="coming-soon-network"
      title={<>Network <span className="font-editorial italic">agenti.</span></>}
      intro="Collabora con gli altri agenti Pronto, senza Whatsapp infiniti e tabelle Excel. Hai un mandato che fatica a vendere? Hai un cliente che cerca un immobile che non hai? Trova il collega giusto in 30 secondi, dividi la provvigione, chiudi più affari."
      preview={(
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="bg-[#F1F4ED] border-2 border-[#1C1C1A] rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <ArrowsClockwise size={18} weight="duotone" className="text-[#7C8B6E]" />
              <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#7C8B6E]">Bacheca · Offro</div>
            </div>
            <div className="text-[13px] font-semibold text-[#1C1C1A] mb-1">Apri un tuo mandato al Network</div>
            <p className="text-[11.5px] text-[#3A3A36] leading-relaxed">
              "Ho una villa a Bergamo Alta in esclusiva da 2 mesi, non riesco a trovare il compratore." → la pubblichi nella bacheca, altri agenti la vedono, ti contattano se hanno un cliente. Co-mediazione semplice.
            </p>
          </div>
          <div className="bg-[#FAF7F1] border-2 border-[#1C1C1A] rounded-xl p-4">
            <div className="flex items-center gap-2 mb-2">
              <Compass size={18} weight="duotone" className="text-[#B58A4E]" />
              <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#B58A4E]">Bacheca · Cerco</div>
            </div>
            <div className="text-[13px] font-semibold text-[#1C1C1A] mb-1">Pubblica una richiesta acquirente</div>
            <p className="text-[11.5px] text-[#3A3A36] leading-relaxed">
              "Cliente cash, cerca trilocale Navigli ristrutturato, max €700k, rogito entro 60gg." → la pubblichi, gli agenti di Milano che hanno un match ti rispondono in 24h.
            </p>
          </div>
        </div>
      )}
      whyNotYet="Una bacheca di collaborazione funziona davvero solo quando c'è una massa critica di agenti attivi nelle tue zone. Stiamo facendo crescere la rete prima: appena ogni grande città italiana avrà almeno 10-15 agenti Pronto attivi, attiviamo il Network e tutti i mandati condivisi compariranno automaticamente. Ti avvisiamo via email quando la tua zona sarà coperta."
      whatItWillDo={[
        { icon: ArrowsClockwise, label: "Condivisione mandati", body: "Apri un tuo immobile in esclusiva al Network: imposti la % di co-mediazione che lasci al partner (es. 40-50%) e i colleghi locali ti contattano se hanno il compratore." },
        { icon: Compass, label: "Richieste acquirenti", body: "Pubblica anonimamente il profilo del tuo cliente compratore (zona, budget, mq). Altri agenti che hanno un immobile che matcha ti scrivono entro 24h." },
        { icon: Handshake, label: "Co-mediazione diretta", body: "Niente chat in-app complicate, niente split automatici: gli accordi li fate via WhatsApp come già oggi tra agenzie, ma con i match già fatti per te." },
        { icon: ShieldCheck, label: "Solo agenti verificati", body: "Possono entrare nel Network solo agenti con REA verificato e portfolio attivo. Niente abusivi, niente perditempo." },
        { icon: MapPin, label: "Filtri per microzona", body: "Vedi solo gli immobili nelle micro-zone OMI che ti interessano e solo le richieste compatibili con il tuo portafoglio. Zero rumore." },
        { icon: Coins, label: "Tracking provvigioni co-mediate", body: "Dashboard dedicata: 'Hai chiuso 2 mandati in co-mediazione questo trimestre per €4.300 di provvigione condivisa'. Vedi il ROI del Network." },
      ]}
      interestSlug="network-agenti"
      interestTitle="Network agenti · collaborazione e co-mediazione"
    />
  );
}
